import * as React from "react";
import type { LucideIcon } from "lucide-react";

import { cn } from "@werkstatt/utils";

export interface StatTileProps extends React.HTMLAttributes<HTMLDivElement> {
  icon?: LucideIcon;
  value: React.ReactNode;
  label: React.ReactNode;
  chips?: React.ReactNode;
}

const StatTile = React.forwardRef<HTMLDivElement, StatTileProps>(
  ({ icon: Icon, value, label, chips, className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        "rounded-[20px] bg-[rgb(var(--sphere-card)_/_var(--sphere-tile-alpha))] p-4",
        className,
      )}
      {...props}
    >
      <div className="flex items-start gap-3">
        {Icon && (
          <Icon className="h-8 w-8 shrink-0 text-[rgb(var(--sphere-accent-rgb))]" />
        )}
        <div className="min-w-0 flex-1">
          <p className="font-display text-2xl font-bold leading-none text-foreground">
            {value}
          </p>
          <p className="mt-1.5 text-sm text-muted-foreground">{label}</p>
          {chips && <div className="mt-2 flex flex-wrap gap-1">{chips}</div>}
        </div>
      </div>
    </div>
  ),
);
StatTile.displayName = "StatTile";

export { StatTile };
